/*// Find all forms
var formButtons = $('.product-card__quick-add-button-new');
if(formButtons.length){
    // Iterate over each form
    formButtons.each(function(index, formButton){
        var $formButton = $(formButton);
        var variantId = $($formButton).attr('data-id');

        // Attach submit handler to this specific form
        // ADD 'async' HERE
        $formButton.on('click', async function(e){
            e.preventDefault();
            
            try {
                // 'await' is now valid inside this async function
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                });

                if (!res.ok) {
                    console.error('Add to cart failed', await res.json());
                    return;
                }

                document.dispatchEvent(new CustomEvent("cart:refresh"));
            } catch (error) {
                console.error('Quick add error:', error);
            }
        });
    });
}*/

$( document ).ready(function() {
    $('body').on('click', '.product-card__quick-add-button-new', async function(e){
        e.preventDefault();
        console.log('Testing here...');
        var variantId = $(this).attr('data-id');

        try {
            // 'await' is now valid inside this async function
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });

            if (!res.ok) {
                console.error('Add to cart failed', await res.json());
                return;
            }

            document.dispatchEvent(new CustomEvent("cart:refresh"));
        } catch (error) {
            console.error('Quick add error:', error);
        }
    });
});